<template>
<b-container style="max-width: 1200px !important">
<b-row>
<b-col cols="12">

<b-row class="justify-content-center align-items-center">
        <h5 style="text-align:center">QUANTEEC x ExoPlayer</h5>
</b-row>
<b-row class="justify-content-center align-items-center">
        <p style="margin-bottom:0px" v-html="$ml.get('pluginexo1')">
            
        </p>
</b-row>

    <b-tabs>
        <b-tab title="Kotlin Legacy">
            <b-row class="mt-2">
                <vue-markdown style="overflow: auto;" class="col-xl-7 col-12" :style="(activePlugin === 'withDRM')?'display: none' : ''" @rendered="onrender">

1) Add the following lines in your settings.gradle or build.gradle files to declare Quanteec repository 
```gradle
repositories {
    ...
    maven {
        url 'https://maven.quanteec.com/repository/internal/'
            credentials {
                username "username"
                password "password"
            }
            authentication {
                basic(BasicAuthentication)
            }
        }
    }
```

2) Declare the Quanteec plugin dependency in your build.gradle file 
```gradle
dependencies {
    ...
    implementation "com.quanteec:quanteecExoPlugin:1.0.3"
}
```

3) Add the following permissions in the AndroidManifest.xml of your project
```xml
    &lt;uses-permission android:name="android.permission.INTERNET" />
    &lt;uses-permission android:name="android.permission.ACCESS_NETWORK_STATE" />
```

4) Implement the ExoPlayer with Quanteec by creating a QuanteecCore with a QuanteecConfig and attach it to exoplayer
```kotlin
// 1 - Create a quanteecConfig with a videoID and a quanteecKey. 
//Useful if the videosource url contains a different token for every user. If an empty String is set, the source url is used.
val quanteecConfig = QuanteecConfig("videoID", "{{streamKey}}");
                   
// 2 - Create a quanteecCore by passing a Context and the QuanteecConfig
val quanteecCore = QuanteecCore(Context, quanteecConfig); 
                   
// 3 - Create a Factory for the QuanteecBaseDataSource
val quanteecDataSourceFatory = QuanteecBaseDataSource.Factory(quanteecCore);

val mExoPlayer = remember(mContext) {
    // 4 - Register the quanteecDataSourceFactory in ExoPlayer
    ExoPlayer.Builder(mContext).setMediaSourceFactory(DefaultMediaSourceFactory(mContext).setDataSourceFactory(quanteecDataSourceFatory) 
    // 5 - Register a QuanteecBandwithMeters in ExoPlayer
    ).setBandwidthMeter(QuanteecBandwidthMeters.Builder(mContext).build() 
    ).build().apply {
        val mediaItem = MediaItem.Builder(
        ).setUri(Uri.parse("https://test.quanteec.com/contents/encodings/vod/d4c2f34b-9a7a-4313-766b-6d-746c-7561-6665-64-a602-3900cee4c72edb/")
        ).build()

       setMediaItem(mediaItem)

        playWhenReady = true
        }
    }

//6 - Register the player in QuanteeCore
quanteecCore.setPlayer(mExoPlayer);
```
                </vue-markdown>
                <ConfigDocExoplayer class="col-xl-5 col-12">

                </ConfigDocExoplayer>
            </b-row>
        </b-tab>
        <b-tab title="Kotlin (QuanteecExoPlugin >v1.1)">
            <b-row class="mt-2">
                <vue-markdown style="overflow: auto;" class="col-xl-7 col-12" :style="(activePlugin === 'withDRM')?'display: none' : ''" @rendered="onrender">

1) Add the following lines in your settings.gradle or build.gradle files to declare Quanteec repository 
```gradle
repositories {
    ...
    maven {
        url 'https://maven.quanteec.com/repository/internal/'
            credentials {
                username "username"
                password "password"
            }
            authentication {
                basic(BasicAuthentication)
            }
        }
    }
```

2) Declare the Quanteec plugin dependency in your build.gradle file 
```gradle
dependencies {
    ...
    implementation "com.quanteec:quanteecExoPlugin:1.1"
    implementation "com.quanteec:quanteecPlugin:1.1"
}
```

3) Add the following permissions in the AndroidManifest.xml of your project
```xml
    &lt;uses-permission android:name="android.permission.INTERNET" />
    &lt;uses-permission android:name="android.permission.ACCESS_NETWORK_STATE" />
```

4) Implement the ExoPlayer with Quanteec by creating a QuanteecCore with a QuanteecConfig and attach it to exoplayer
```kotlin
// 1 - Create a quanteecConfig with a videoID and a quanteecKey. 
//Useful if the videosource url contains a different token for every user. If an empty String is set, the source url is used.
val quanteecConfig = QuanteecConfig("videoID", "{{streamKey}}");
                   
// 2 - Create a quanteecCore by passing a Context and the QuanteecConfig
val quanteecCore = QuanteecExoCore(Context, quanteecConfig); 
                   
// 3 - Create a Factory for the QuanteecBaseDataSource
val quanteecDataSourceFatory = QuanteecBaseDataSource.Factory(quanteecCore);

val mExoPlayer = remember(mContext) {
    // 4 - Register the quanteecDataSourceFactory in ExoPlayer
    ExoPlayer.Builder(mContext).setMediaSourceFactory(DefaultMediaSourceFactory(mContext).setDataSourceFactory(quanteecDataSourceFatory) 
    // 5 - Register a QuanteecBandwithMeters in ExoPlayer
    ).setBandwidthMeter(QuanteecBandwidthMeters.Builder(mContext).build() 
    ).build().apply {
        val mediaItem = MediaItem.Builder(
        ).setUri(Uri.parse("https://test.quanteec.com/contents/encodings/vod/d4c2f34b-9a7a-4313-766b-6d-746c-7561-6665-64-a602-3900cee4c72edb/")
        ).build()

       setMediaItem(mediaItem)

        playWhenReady = true
        }
    }

//6 - Register the player in QuanteeCore
quanteecCore.setPlayer(mExoPlayer);
```
                </vue-markdown>
                <ConfigDocExoplayer class="col-xl-5 col-12">

                </ConfigDocExoplayer>
            </b-row>
        </b-tab>
        <b-tab title="Java Legacy">
            <b-row class="mt-2">
                <vue-markdown style="overflow: auto;" class="col-xl-7 col-12" :style="(activePlugin === 'withDRM')?'display: none' : ''" @rendered="onrender">
1) Add the following lines in your settings.gradle or build.gradle files to declare Quanteec repository 
```gradle
repositories {
    ...
    maven {
        url 'https://maven.quanteec.com/repository/internal/'
            credentials {
                username "username"
                password "password"
            }
            authentication {
                basic(BasicAuthentication)
            }
        }
    }
```

2) Declare the Quanteec plugin dependency in your build.gradle file 
```gradle
dependencies {
    ...
    implementation "com.quanteec:quanteecExoPlugin:1.0.3"
}
```

3) Add the following permissions in the AndroidManifest.xml of your project

```xml
    &lt;uses-permission android:name="android.permission.INTERNET" />
    &lt;uses-permission android:name="android.permission.ACCESS_NETWORK_STATE" />
```
4) Implement the ExoPlayer with Quanteec by creating a QuanteecCore with a QuanteecConfig and attach it to exoplayer
```kotlin
// 1 - Create a quanteecConfig with a videoID and a quanteecKey
//Useful if the videosource url contains a different token for every user. If an empty String is set, the source url is used.
QuanteecConfig quanteecConfig = new QuanteecConfig("videoID", "{{streamKey}}");
                   
// 2 - Create a quanteecCore by passing a Context and the QuanteecConfig
QuanteecCore quanteecCore = new QuanteecCore(Context, quanteecConfig); 
                   
// 3 - Create a Factory for the QuanteecBaseDataSource
QuanteecBaseDataSource.Factory quanteecDataSourceFatory = QuanteecBaseDataSource.Factory(quanteecCore);

ExoPlayer.Builder playerBuilder = 
    new ExoPlayer.Builder(/*context=*/ context)
        .setMediaSourceFactory(
            new DefaultMediaSourceFactory(/* context= */ this).
            setDataSourceFactory(quanteecBaseDataSourceFactory) // 4 - Register the quanteecDataSourceFactory in ExoPlayer
        ).setBandwidthMeter(new QuanteecBandwidthMeters()); // 5 - Register a QuanteecBandwithMeters in ExoPlayer
    
ExoPlayer player = playerBuilder.build()

//6 - Register the player in QuanteeCore
quanteecCore.setPlayer(player);

StyledPlayerView  playerView = findViewById(R.id.player_view);
playerView.setPlayer(player);
```
                </vue-markdown>
                <ConfigDocExoplayerJava class="col-xl-5 col-12">

                </ConfigDocExoplayerJava>
            </b-row>
        </b-tab>
        <b-tab title="Java (QuanteecExoPlugin >v1.1)">
            <b-row class="mt-2">
                <vue-markdown style="overflow: auto;" class="col-xl-7 col-12" :style="(activePlugin === 'withDRM')?'display: none' : ''" @rendered="onrender">
1) Add the following lines in your settings.gradle or build.gradle files to declare Quanteec repository 
```gradle
repositories {
    ...
    maven {
        url 'https://maven.quanteec.com/repository/internal/'
            credentials {
                username "username"
                password "password"
            }
            authentication {
                basic(BasicAuthentication)
            }
        }
    }
```

2) Declare the Quanteec plugin dependency in your build.gradle file 
```gradle
dependencies {
    ...
    implementation "com.quanteec:quanteecExoPlugin:1.1"
    implementation "com.quanteec:quanteecPlugin:1.0"
}
```

3) Add the following permissions in the AndroidManifest.xml of your project

```xml
    &lt;uses-permission android:name="android.permission.INTERNET" />
    &lt;uses-permission android:name="android.permission.ACCESS_NETWORK_STATE" />
```
4) Implement the ExoPlayer with Quanteec by creating a QuanteecCore with a QuanteecConfig and attach it to exoplayer
```kotlin
// 1 - Create a quanteecConfig with a videoID and a quanteecKey
//Useful if the videosource url contains a different token for every user. If an empty String is set, the source url is used.
QuanteecConfig quanteecConfig = new QuanteecConfig("videoID", "{{streamKey}}");
                   
// 2 - Create a QuanteecExoCore by passing a Context and the QuanteecConfig
QuanteecCore quanteecCore = new QuanteecExoCore(Context, quanteecConfig); 
                   
// 3 - Create a Factory for the QuanteecBaseDataSource
QuanteecBaseDataSource.Factory quanteecDataSourceFatory = QuanteecBaseDataSource.Factory(quanteecCore);

ExoPlayer.Builder playerBuilder = 
    new ExoPlayer.Builder(/*context=*/ context)
        .setMediaSourceFactory(
            new DefaultMediaSourceFactory(/* context= */ this).
            setDataSourceFactory(quanteecBaseDataSourceFactory) // 4 - Register the quanteecDataSourceFactory in ExoPlayer
        ).setBandwidthMeter(new QuanteecBandwidthMeters()); // 5 - Register a QuanteecBandwithMeters in ExoPlayer
    
ExoPlayer player = playerBuilder.build()

//6 - Register the player in QuanteeCore
quanteecCore.setPlayer(player);

StyledPlayerView  playerView = findViewById(R.id.player_view);
playerView.setPlayer(player);
```
                </vue-markdown>
                <ConfigDocExoplayerJava class="col-xl-5 col-12">

                </ConfigDocExoplayerJava>
            </b-row>
        </b-tab>
    </b-tabs>



</b-col>
</b-row>
</b-container>
</template>
<script>
import ConfigDocExoplayer from '@/components/documentation/plugins/ConfigDocExoplayer.vue';
import ConfigDocExoplayerJava from '@/components/documentation/plugins/ConfigDocExoplayerJava.vue'
import VueMarkdown from 'vue-markdown';
import Prism from 'prismjs';
import 'prismjs/themes/prism-twilight.css';
import 'prismjs/components/prism-kotlin.js';
import 'prismjs/components/prism-java.js';
import 'prismjs/components/prism-gradle.js';
export default {
  name: 'Dashjs',
  data: function() {
    return {
     activePlugin:"noDRM",     
    }
  },
  props: [
      "streamKey"
  ],
  components: {
      VueMarkdown,
      ConfigDocExoplayer,
      ConfigDocExoplayerJava
  },
  mounted: function() {

    this.$nextTick(() => {
        Prism.highlightAll()
      });  
  },
  methods: {
      onrender() {
        this.$nextTick(() => {
        Prism.highlightAll()
      });  
     }      
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>